export default "__VITE_ASSET__BwFoFUpI__"